import { Controller } from "@hotwired/stimulus"

// Toggles the responsive sidebar drawer on mobile and closes it on
// navigation, Escape, or scrim click.
export default class extends Controller {
  static targets = ["app"]

  connect() {
    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKey)
    // Close the drawer after a Turbo navigation completes.
    this._onNav = () => this.close()
    document.addEventListener("turbo:load", this._onNav)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey)
    document.removeEventListener("turbo:load", this._onNav)
  }

  toggle() {
    this.element.classList.toggle("nav-open")
  }

  open() {
    this.element.classList.add("nav-open")
  }

  close() {
    this.element.classList.remove("nav-open")
  }
}
